import { render } from "./EmptyReport.vue?vue&type=template&id=1f595748&scoped=true"
import script from "./EmptyReport.vue?vue&type=script&lang=js"
export * from "./EmptyReport.vue?vue&type=script&lang=js"

import "./EmptyReport.vue?vue&type=style&index=0&id=1f595748&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f595748"]])

export default __exports__